import { OmniDropdownComponent } from "../../../../shared/components/omni-components";

const CampaignTaxonomySyncPopup = ({
    top,
    left,
    index,
    fieldName,
    selectedDDValue,
    dropdownValue,
    initialValue,
    ddValues,
    applyButtonId,
    delimiterValue,
    onInputChange,
    onDropdownChange,
    onCancel,
    onApply,
    taxonomyFieldList
}) => {
    const showInput = !ddValues || ddValues.length === 0;

    return (
        <div
            className="edit-popup"
            style={{
                width: '349px',
                position: 'absolute',
                top: `${top}px`,
                left: `${left}px`,
                zIndex: 9999,
                background: 'white',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
            }}
        >
            <div className="dropdown-menu1">
                <div className="dropdown-content" style={{ display: 'flex', flexDirection: 'column' }}>
                    <section>
                        <p className="object-title">{fieldName}</p>
                    </section>
                    <section style={{ padding: '0px 24px' }}>
                        <div style={{ margin: '15px 0 20px 0' }}>
                            {showInput ? (
                                <input
                                    className="input text medium"
                                    value={selectedDDValue?.name === fieldName ? selectedDDValue.value : initialValue}
                                    onChange={(e) => onInputChange(fieldName, applyButtonId, delimiterValue, taxonomyFieldList, e)}
                                />
                            ) : (
                                <OmniDropdownComponent
                                    key={index}
                                    value={
                                        selectedDDValue?.name === fieldName && selectedDDValue?.value
                                            ? [selectedDDValue]
                                            : [dropdownValue]
                                    }
                                    options={ddValues}
                                    originalOptions={ddValues}
                                    hidefooter={true}
                                    onDropdownChange={(e) =>
                                        onDropdownChange(e.detail.id, fieldName, applyButtonId, ddValues, delimiterValue)
                                    }
                                />
                            )}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <button className="tertiary medium" onClick={onCancel}>Cancel</button>
                            <button className="medium" id={applyButtonId} onClick={onApply}>
                                Apply
                            </button>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};
export default CampaignTaxonomySyncPopup;
